module.exports = __webpack_public_path__ + "img/first.1877c783.jpg";